import "../assets/preloader.css";

export default function Preloader({ src }) {
  return (
    <div className="preloader-wrapper">
      <div className="preloader-circle">
        <div className="preloader-spinner"></div>
        <img
          src={src}
          alt="Kabupaten Sampang"
          className="preloader-logo"
        />
      </div>
      <p className="preloader-text">Memuat data, mohon tunggu...</p>
    </div>
  );
}